import React, { useState } from 'react'
import { Link } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { FlowMetaData } from '../../../../@types/types'
import {
  createTypeChangedListing,
  ListingCopyTargetSegmentation,
} from '../../../../api/realEstate/listingTypeChangeApi'
import { ListingTypeChangeModal } from './ListingTypeChangeModal'
import { getSourceRealEstateId, hasListingTypeChangeCopyContext } from './listingTypeChangeContext'

type ListingTypeChangeCtaProps = {
  flowMetadata: FlowMetaData
}

export const ListingTypeChangeCta = ({ flowMetadata }: ListingTypeChangeCtaProps) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submissionError, setSubmissionError] = useState(false)

  const sourceRealEstateId = getSourceRealEstateId()

  if (!hasListingTypeChangeCopyContext() || !sourceRealEstateId) {
    return null
  }

  const submitListingTypeChange = async (target: ListingCopyTargetSegmentation) => {
    setIsSubmitting(true)
    setSubmissionError(false)

    try {
      const editorUrl = await createTypeChangedListing(sourceRealEstateId, target)
      window.location.assign(editorUrl)
    } catch {
      setIsSubmitting(false)
      setSubmissionError(true)
    }
  }

  return (
    <>
      <Link as='button' data-testid='listing-type-change-cta' variant={'blue'} onClick={() => setIsOpen(true)}>
        {t('listingTypeChange.cta')}
      </Link>
      <ListingTypeChangeModal
        flowMetadata={flowMetadata}
        isOpen={isOpen}
        isSubmitting={isSubmitting}
        onClose={() => setIsOpen(false)}
        onSubmit={(target) => void submitListingTypeChange(target)}
        submissionError={submissionError}
      />
    </>
  )
}
